import ButtonUI from "@UI/ButtonUI";
import InputNumberUI from "@UI/InputNumberUI";
import InputUI from "@UI/InputUI";
import RadioButtonUI from "@UI/RadioButtonUI";
import { inject, observer } from "mobx-react";
import { InputSwitch } from "primereact/inputswitch";
import { ListBox } from "primereact/listbox";
import { Message } from "primereact/message";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import AddAgreement from "./AddAgreement";
import AddContract from "./AddContract";

import "./style.scss";

const Ord = inject("mainStore")(
    observer(({ mainStore, dataKey, error = false }) => {
        const detailData = mainStore.getMainStore("detailData") || {};
        const vendorInfo = detailData?.vendorInfo || {};

        const [organization, setOrganization] = useState(null);
        const [selectOrg, setSelectOrg] = useState(null);
        const [contract, setContract] = useState(false);
        const [contractDop, setContractDop] = useState([]);
        const [refetch, setRefetch] = useState(true);
        const [errorInn, setErrorInn] = useState(false);

        const navigation = useNavigate();

        const legalType = vendorInfo.legalType || "LEGAL_TYPE_LEGAL";
        const viaAgency = vendorInfo.workViaAgency;
        const innValue = vendorInfo.INN || "";
        const disableContragentButton = !innValue || !vendorInfo.fullOpf || vendorInfo.ozonId;

        const isDisableButtonAddContract = contract && contract[contract.length - 1]?._id ? true : false;

        // Инициализация при монтировании
        useEffect(() => {
            if (dataKey !== "add") {
                getContract();
            } else {
                const initialVendorInfo = { ...vendorInfo, legalType: "LEGAL_TYPE_LEGAL", kpp: "", fullOpf: "", INN: "" };

                mainStore.setMainStore("detailData.vendorInfo", initialVendorInfo);
                setContract([defaultData]);
                setContractDop([]);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        const getContract = async () => {
            setRefetch(false);
            const resp = await mainStore.getByUrl(`promo/contracts?filters[vendorId]=${dataKey}&filter[rows]=100`);

            if (resp && resp.success) {
                const contracts = resp.data.reduce(
                    (acc, item) => {
                        if (item.contractType === "CONTRACT_TYPE_SERVICE") {
                            acc.service.push(item);
                        } else if (item.contractType === "CONTRACT_TYPE_ADDITIONAL_AGREEMENT") {
                            acc.additional.push(item);
                        }

                        return acc;
                    },
                    { service: [], additional: [] },
                );

                setContract(contracts.service.length ? contracts.service : [defaultData]);
                setContractDop(contracts.additional ? contracts.additional : []);
                setRefetch(true);
            } else {
                setRefetch(true);
            }
        };

        const updateVendorInfo = (patch) => {
            mainStore.setMainStore("detailData.vendorInfo", {
                ...vendorInfo,
                ...patch,
            });
        };

        const getOrganization = async (inn) => {
            if (vendorInfo.ozonId) return;

            const resp = await mainStore.getByUrl(`promo/getOrganizationsByINN?inn=${inn}`, false, "", false, false);

            if (resp && resp.success) {
                setOrganization(resp.data);
                setSelectOrg(false);
            } else {
                updateVendorInfo({ INN: inn });
            }
        };

        const handleChangeRadio = (e, key) => {
            // ожидаем, что RadioButtonUI даёт { value, target: { id } }
            const field = e.target?.id || e.id || "legalType";
            const value = e.value;

            setErrorInn(false);

            updateVendorInfo({
                [field]: value,
                kpp: "",
                address: "",
                fullOpf: "",
                INN: "",
                workViaAgency: key === "isRf" ? !value : vendorInfo,
                // INN: value ? vendorInfo.INN : "",
            });
        };

        const handleChangeOrg = async (e) => {
            const org = e.value;
            setSelectOrg(org);

            const kpp = org.requisites && org.requisites.kpp ? org.requisites.kpp : "";
            const fullOpf = org.name || "";
            const address = org.postAddress || "";

            updateVendorInfo({
                kpp,
                fullOpf,
                address,
            });
        };

        const handleIdOrd = () => {
            getIdOrd();
        };

        const getIdOrd = async () => {
            const obj = {
                legalType: vendorInfo.legalType || "LEGAL_TYPE_LEGAL",
                kpp: vendorInfo.kpp || "",
                fullOpf: vendorInfo.fullOpf || "",
                isOpc: null,
                isPp: null,
            };

            const body = {
                ...detailData,
                vendorInfo: {
                    ...vendorInfo,
                    ...obj,
                },
            };

            if (dataKey === "add") {
                const postResp = await mainStore.postByUrl("/promo/vendors", body, "detailData", true, false);

                if (postResp && postResp.success) {
                    const resp = await mainStore.getByUrl(`promo/createOrgFromVendorInOzon/${postResp.data._id}`, obj, "", false);
                    if (resp && resp.success) {
                        mainStore.setMainStore("detailData", {});
                        navigation(`/offers/${resp.data._id}`);
                    }
                }
            } else {
                const putResp = await mainStore.putByUrl(`/promo/vendors/${detailData._id}`, body, false, false);

                if (putResp && putResp.success) {
                    await mainStore.getByUrl(`promo/createOrgFromVendorInOzon/${detailData._id}`, obj, "detailData", false, false);
                }
            }
        };

        const handleINN = async (e) => {
            setErrorInn(false);
            const value = e.value;

            if (!vendorInfo.isRf) {
                const lengthNeeded = legalType === "LEGAL_TYPE_LEGAL" ? 10 : 12;

                if (value && value.toString().length === lengthNeeded) {
                    const isExist = await mainStore.getByUrl("/promo/vendors", {
                        filters: { name: value.toString() },
                    });

                    if (isExist.data.length) {
                        return setErrorInn(`Контрагент с ИНН ${value} уже существует в системе под вендором «${isExist.data[0].name}». Используйте существующую запись`);
                    }

                    updateVendorInfo({ INN: value });

                    getOrganization(value);
                }
            } else {
                if (value.toString().length < 17) {
                    updateVendorInfo({ INN: value });
                }
            }
        };

        const countryTemplate = (option) => {
            return (
                <div className="item__org">
                    <span>{option.requisites.inn}</span>
                    <span>{option.name}</span>
                </div>
            );
        };

        return (
            <div className="ord-block">
                <div className="radio__block">
                    <RadioButtonUI
                        disabled={vendorInfo.ozonId}
                        value={vendorInfo.isRf ?? false}
                        onChange={(e) => {
                            handleChangeRadio(e, "isRf");
                        }}
                        radioData={radioButtonsIsRf}
                    />
                </div>

                <div className="ord-block__agreement">
                    <span className="ord-block__agreement-text">Укажите данные для пользовательского соглашений</span>
                    {!vendorInfo.isRf ? (
                        <div className="ord-block__switch">
                            <InputSwitch
                                checked={viaAgency}
                                onChange={(e) => {
                                    updateVendorInfo({ workViaAgency: e.value });
                                }}
                                disabled={vendorInfo.ozonId}
                            />
                            <label>Работаем через агентство</label>
                        </div>
                    ) : null}
                </div>

                {vendorInfo.isRf || viaAgency ? (
                    <Message
                        className="ord-block__message"
                        content={
                            <>
                                <i className="pi pi-exclamation-circle" />
                                <div className="ord-block__message-text">
                                    <span>
                                        1. В данном кейсе первым шагом вам необходимо перейти в Ozon ORD и пройти все шаги по регламенту ниже.
                                        <br />
                                        <a href="https://drive.google.com/file/d/1HWZ2jPKyo0LZJmGs7ELpNtHn_9X7qcF6/view" target="_blank" rel="noreferrer">
                                            Регламент работы с РА в Ozon ORD
                                        </a>
                                    </span>
                                    <span>
                                        2. Обратите внимание: в CMS нужно заполнить поле с юридическим названием партнёра. Это название будет фигурировать в пользовательском соглашении, так как именно этот партнёр является получателем персональных
                                        данных пользователей.
                                    </span>
                                </div>
                            </>
                        }
                    />
                ) : null}

                {!vendorInfo.isRf ? viaAgency ? <span className="ord-block__text">Правововой статус</span> : <span className="title">Шаг 1. Создание контрагента</span> : null}

                {!vendorInfo.isRf ? (
                    <div className="radio__block">
                        <RadioButtonUI value={legalType} onChange={handleChangeRadio} radioData={radioButton} disabled={vendorInfo.ozonId} />
                    </div>
                ) : null}

                <div className="block">
                    <div className="wrapper">
                        <label>ИНН*</label>
                        <InputNumberUI
                            value={innValue}
                            onChange={handleINN}
                            maxLength={!vendorInfo.isRf ? (legalType === "LEGAL_TYPE_LEGAL" ? 10 : 12) : 16}
                            useGrouping={false}
                            placeholder={!vendorInfo.isRf ? (legalType === "LEGAL_TYPE_LEGAL" ? "0000000000" : "000000000000") : "Укажите данные"}
                            disabled={vendorInfo.ozonId}
                            error={innValue ? false : true}
                        />
                        {organization && !selectOrg ? <ListBox onChange={handleChangeOrg} options={organization} optionLabel="name" itemTemplate={countryTemplate} className="w-full md:w-14rem" listStyle={{ maxHeight: "250px" }} /> : null}
                        {errorInn ? <span className="ord-block__error">{errorInn}</span> : null}
                    </div>

                    <div className="row">
                        <InputUI
                            value={vendorInfo.address}
                            disabled={vendorInfo.isRf ? vendorInfo.ozonId : false}
                            label="Юридический адрес"
                            placeholder={vendorInfo.isRf ? "Укажите данные" : "Обновится после указания ИНН"}
                            onChange={(e) => {
                                updateVendorInfo({ address: e.target.value });
                            }}
                        />
                        <InputUI
                            value={vendorInfo.fullOpf}
                            onChange={(e) => {
                                updateVendorInfo({ fullOpf: e.target.value });
                            }}
                            placeholder={vendorInfo.isRf ? "Укажите данные" : "Обновится после указания ИНН"}
                            label="Юридическое название вендора"
                            required
                            disabled={vendorInfo.ozonId}
                        />
                    </div>

                    {!vendorInfo.isRf ? (
                        <div className="wrapper">
                            {!viaAgency && (
                                <InputUI
                                    value={vendorInfo.kpp}
                                    onChange={(e) => {
                                        updateVendorInfo({ kpp: e.target.value });
                                    }}
                                    placeholder="Укажите данные"
                                    useGrouping={false}
                                    label="КПП"
                                    disabled={vendorInfo.ozonId}
                                />
                            )}
                        </div>
                    ) : null}
                </div>

                {!vendorInfo.isRf && !viaAgency ? (
                    <>
                        <ButtonUI className="button__rate" label="Сгенерировать контрагента" icon="pi pi-user-plus" outlined onClick={handleIdOrd} style={{ width: "100%" }} disabled={disableContragentButton} />

                        {vendorInfo.fullOpf && vendorInfo.ozonId ? (
                            <div className="ord__id">
                                <div className="number">
                                    {"ID ORD "}
                                    <span>{vendorInfo.ozonId}</span>
                                </div>
                                <span className="name">{vendorInfo.fullOpf}</span>
                            </div>
                        ) : null}

                        {refetch && contract && contract.map((item, idx) => <AddContract key={idx} item={item} getContract={getContract} select={select} />)}

                        <ButtonUI
                            className="button__rate"
                            label={"Добавить новый договор"}
                            icon="pi pi-plus"
                            outlined
                            onClick={() => setContract((prev) => (prev || []).concat([defaultData]))}
                            style={{ width: "100%" }}
                            disabled={!vendorInfo.ozonId || !isDisableButtonAddContract}
                        />

                        {isDisableButtonAddContract && (
                            <div className={`dop__block ${vendorInfo.ozonId ? "" : "disable"}`}>
                                <span className="title">Шаг 3. Добавить дополнительное соглашение</span>
                                <div className="link">
                                    <i className="pi pi-info-circle" />
                                    <a
                                        style={{
                                            pointerEvents: vendorInfo.ozonId ? "all" : "none",
                                        }}
                                        href="https://drive.google.com/drive/folders/1jjTrOXB99uHAHadFI6oHJIiyogJHN68V"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Ссылка на диск с договорами
                                    </a>
                                </div>
                                {refetch && contractDop.map((item, idx) => <AddAgreement key={idx} item={item} getContract={getContract} contract={contract} select={select} />)}
                            </div>
                        )}

                        {isDisableButtonAddContract && (
                            <ButtonUI
                                className="button__rate"
                                label={"Добавить новое доп.соглашение"}
                                icon="pi pi-plus"
                                outlined
                                onClick={() => setContractDop((prev) => (prev || []).concat([defaultData]))}
                                style={{ width: "100%" }}
                                disabled={!vendorInfo.ozonId}
                            />
                        )}
                    </>
                ) : null}
            </div>
        );
    }),
);

const radioButtonsIsRf = [
    { label: "Россия", value: false, id: "isRf" },
    { label: "Другая страна", value: true, id: "isRf" },
];

const radioButton = [
    { label: "Юр.лицо", value: "LEGAL_TYPE_LEGAL", id: "legalType" },
    { label: "Физ.лицо", value: "LEGAL_TYPE_INDIVIDUAL", id: "legalType" },
    { label: "ИП", value: "LEGAL_TYPE_ENTREPRENEUR", id: "legalType" },
];

const defaultData = {
    subjectType: "SUBJECT_TYPE_OTHER",
    contractNumber: "",
    contractDate: "",
    expirationDate: "",
    price: "",
};

const select = [
    { label: "Иное", type: "SUBJECT_TYPE_OTHER" },
    { label: "Распространение рекламы", type: "SUBJECT_TYPE_DISTRIBUTION" },
    { label: "Посредничество", type: "SUBJECT_TYPE_INTERMEDIARY" },
    {
        label: "Договор на организацию распространения рекламы",
        type: "SUBJECT_TYPE_ORGANISATION",
    },
    { label: "Представительство", type: "SUBJECT_TYPE_REPRESENTATION" },
];

export default Ord;
